import { Aliment } from '../models/aliments/aliment.ts';
import GenerateAlimentsQuery from '../models/helpers/generateAlimentsQuery.ts';
import { AlimentSearchParam } from '../models/searchParams/alimentSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const AlimentsController = {
    get: (tableSearchParam: TableSearchParam, searchParam: AlimentSearchParam) => {
        let url = `aliments/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateAlimentsQuery(searchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`aliment/${id}`);
    },
    post: (aliment: Aliment) => {
        return ApiClient.post('aliment', aliment);
    },
    put: (aliment: Aliment) => {
        return ApiClient.put(`aliment/${aliment.alimentID}`, aliment);
    },
    delete: (id: number) => {
        return ApiClient.delete(`aliment/${id}`)
    }
};
export default AlimentsController;